export default __webpack_public_path__ + "static/media/CompleteCalendarSuccess.c448d860.svg";